<template>
  <div class="layout-order">
    <top-bar></top-bar>
    <div class="body">
      <div class="logos main">
        <router-link tag="div" to="/" class="logo-img mt20">
          <img src="../assets/imgs/logo.png" width="200" />
        </router-link>
        <!-- <div class="steps-box">
          <a-steps :current="current">
            <a-step>
              <template slot="title">我的购物车</template>
            </a-step>
            <a-step title="确认订单" />
            <a-step title="提交订单" />
          </a-steps>
        </div> -->
      </div>
    </div>
    <router-view></router-view>
    <foot-bar></foot-bar>
  </div>
</template>
<script>
import topBar from './sideBar/topBar'
import footBar from './sideBar/footBar'
export default {
  name: 'layoutOrder',
  components: {
    topBar,
    footBar
  },
  data () {
    return {
      current: 0
    }
  }
}
</script>
<style lang="less" scoped>
.logos {
    // display: flex;
    // justify-content: space-between;
    .logo-img {
      cursor: pointer;
    }

    .steps-box {
      width: 500px;
    }
  }
</style>
<style lang="less">
// .steps-box {
//   .ant-steps-item-finish .ant-steps-item-icon {
//     border-color: #E69B47;
//     .ant-steps-icon {
//       color: #E69B47;
//     }
//   }
//   .ant-steps-item-finish
//     > .ant-steps-item-content
//     > .ant-steps-item-title::after {
//     background: #E69B47;
//   }
//   .ant-steps-item-process .ant-steps-item-icon {
//     background: #E69B47;
//     border-color: #E69B47;
//   }
// }
</style>
